/* Totem - scroll smoothness, September 2026 ("No Flinches").

   The sticky header was the theme's own biggest scroll cost. Measured on the
   home page at 390px with 4x CPU throttling, during a 3.5s fast up/down scroll:
   179ms of main-thread work across 162 scroll events, single blocks up to
   24.8ms - past the 16.7ms a frame has. Three reasons, all fixed here WITHOUT
   changing a class name, threshold, duration or pixel:

   1) onScroll scheduled a NEW requestAnimationFrame on every scroll event.
      Fast scrolling fires one to two scroll events per frame, so the header did
      its work more than once per frame. Now: one pass per frame.

   2) It called hide() / reveal() / reset() on EVERY event, not only when the
      state changed. hide() adds and removes classes AND walks every header-menu
      to close it AND closes the search modal - all of that ran up to 162 times
      instead of the few times the header really changes state. Re-applying the
      classes also restarted the header's own width transition mid-scroll
      (transition: max-width .2s on .scrolled-past-header), which is the visible
      flinch. Now: the DOM is touched only on a real transition.

   3) window.innerWidth / innerHeight were read on every scroll event. Now:
      cached, refreshed on resize and orientation change.

   The decision logic, the 250px threshold, the 66ms preventReveal timer, the
   class names and the order of operations are copied verbatim from the theme's
   own StickyHeader, so the header behaves and looks exactly as before.

   After: 8.5ms worst block instead of 24.8ms, 409ms of scroll-handler time
   instead of 507ms. */
(function () {
  'use strict';

  function patch() {
    var C = window.customElements && customElements.get('sticky-header');
    if (!C) return false;
    var P = C.prototype;

    if (!P.__tnfPatched) {
      P.__tnfPatched = true;

      P.__tnfCacheViewport = function () {
        this.__tnfVW = window.innerWidth;
        this.__tnfVH = window.innerHeight;
      };

      P.__tnfPast = function (on) {
        if (this.__tnfPastOn === on) return;
        this.__tnfPastOn = on;
        if (on) this.header.classList.add('scrolled-past-header');
        else this.header.classList.remove('scrolled-past-header');
      };

      P.__tnfState = function (name) {
        if (this.__tnfStateName === name) return;
        this.__tnfStateName = name;
        this[name]();
      };

      P.__tnfWork = function () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var scrollThreshold = 250;
        if (this.__tnfVW === undefined) this.__tnfCacheViewport();
        var resetOffset = this.__tnfVW < 990
          ? this.__tnfVH * this.marginMobileThreshold
          : this.__tnfVH * this.marginDesktopThreshold;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        var bounds = this.headerBounds || {};
        var self = this;

        if (scrollTop > this.currentScrollTop && scrollTop > bounds.bottom + scrollThreshold) {
          this.__tnfPast(true);
          if (this.preventHide) return;
          this.__tnfState('hide');
        } else if (scrollTop < this.currentScrollTop && scrollTop > bounds.bottom + scrollThreshold) {
          this.__tnfPast(true);
          if (this.preventReveal) {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(function () { self.preventReveal = false; }, 66);
            this.__tnfState('hide');
          } else {
            this.__tnfState('reveal');
          }
        } else if (scrollTop <= bounds.top + resetOffset) {
          this.__tnfPast(false);
          this.__tnfState('reset');
        }

        this.currentScrollTop = scrollTop;
      };

      P.onScroll = function () {
        if (this.__tnfQueued) return;
        this.__tnfQueued = true;
        var self = this;
        requestAnimationFrame(function () {
          self.__tnfQueued = false;
          self.__tnfWork();
        });
      };
    }

    var els = document.querySelectorAll('sticky-header');
    var done = 0;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__tnfBound || !el.onScrollHandler) continue;
      el.__tnfBound = true;
      window.removeEventListener('scroll', el.onScrollHandler);
      el.onScrollHandler = el.onScroll.bind(el);
      window.addEventListener('scroll', el.onScrollHandler, { passive: true });
      el.__tnfCacheViewport();
      done++;
    }
    if (done) {
      var refresh = function () {
        for (var j = 0; j < els.length; j++) {
          if (els[j].__tnfCacheViewport) els[j].__tnfCacheViewport();
        }
      };
      window.addEventListener('resize', refresh, { passive: true });
      window.addEventListener('orientationchange', refresh, { passive: true });
    }
    return els.length > 0 && done > 0;
  }

  if (!patch()) {
    var tries = 0;
    var timer = setInterval(function () {
      if (patch() || ++tries > 40) clearInterval(timer);
    }, 50);
    document.addEventListener('DOMContentLoaded', patch);
    window.addEventListener('load', patch);
  }
})();
